
<template>
  <el-form ref="editor" size="small" label-width="12rem" :rules="rules" label-position="right" :model="entity"
    style="padding:0 3rem 0 0;text-align:left;">
    <el-row :gutter="10">
      <el-col :span="24">
        <el-form-item label="医疗类别：" prop="med_type">
          <dict-selector :value.sync="entity.med_type" dict-type="med_type" isMed auto-first @change="queryDise" />
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label="病种：">
          <el-select v-model="entity.dise_codg" value-key="placeDicValCode" placeholder="请选择" class="f-w" filterable clearable
            size="small" @change="diseChange">
            <el-option v-for="item in diseItem" :key="item.placeDicValCode" :label="item.placeDicName"
              :value="item.placeDicValCode" />
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label="个人结算方式：" prop="psn_setlway">
          <dict-selector :value.sync="entity.psn_setlway" dict-type="psn_setlway" isMed auto-first />
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label="个人账户使用标志：" prop="acct_used_flag">
          <dict-selector :value.sync="entity.acct_used_flag" dict-type="acct_used_flag" isMed auto-first />
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label="外购处方标志：" prop="rx_circ_flag">
          <dict-selector :value.sync="entity.rx_circ_flag" dict-type="rx_circ_flag" isMed auto-first />
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label="是否第三方责任申请：" prop="ttp_resp">
          <el-radio :value.sync="entity.ttp_resp" label="1">是</el-radio>
          <el-radio :value.sync="entity.ttp_resp" label="0">否</el-radio>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label="就诊方式：" prop="mdtrt_mode">
          <dict-selector :value.sync="entity.mdtrt_mode" dict-type="mdtrt_type" isMed auto-first />
        </el-form-item>
      </el-col>
      <!-- <el-col :span="24">
        <el-form-item label="中途结算标志：" prop="mid_setl_flag">
          <dict-selector :value.sync="entity.mid_setl_flag" dict-type="mid_setl_flag" isMed auto-first />
        </el-form-item>
      </el-col> -->
      <!-- <el-col :span="24">
        <el-form-item label="生育类别：">
          <dict-selector :value.sync="entity.matn_type" dict-type="matn_type" isMed />
        </el-form-item>
      </el-col> -->
      <el-col :span="24">
        <el-form-item label="生育费用类别：">
          <dict-selector :value.sync="entity.matn_fee_flag" dict-type="matn_fee_flag" isMed />
        </el-form-item>
      </el-col>

      <el-col :span="24">
        <el-form-item label="计划生育手术类别：">
          <dict-selector :value.sync="entity.birctrl_type" dict-type="birctrl_type" isMed />
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label="计划生育手术或生育日期：">
          <el-date-picker v-model="entity.birctrl_matn_date " type="date" placeholder="请选择计划生育手术或生育日期" style="width:100%"
            value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label="终止妊娠月数：">
          <el-input type="number" :max="10" :min="0" placeholder="请输入终止妊娠月数" v-model.number="entity.expi_gestation_nub_of_m" style="width:100%">
          </el-input>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import medApi from "@/common/medApi";
export default {
  name: "selectorMdtrtinfo",
  data () {
    return {
      entity: {
        dise_codg: 'T01003',
        med_type: '11',
        rx_circ_flag: '0',
        ttp_resp: '0',
        psn_setlway: '1',
        acct_used_flag: '1',
        // mid_setl_flag: '0',
        mdtrt_mode: '1'
      },
      diseItem: [],
      rules: {
        dise_codg: [{ required: true, message: "请选择", trigger: "blur" }],
        med_type: [{ required: true, message: "请选择", trigger: "blur" }],
        ttp_resp: [{ required: true, message: "请选择", trigger: "blur" }],
        rx_circ_flag: [{ required: true, message: "请选择", trigger: "blur" }],
        psn_setlway: [{ required: true, message: "请选择", trigger: "blur" }],
        acct_used_flag: [{ required: true, message: "请选择", trigger: "blur" }],
        // mid_setl_flag: [{ required: true, message: "请选择", trigger: "blur" }],
        mdtrt_mode: [{ required: true, message: "请选择", trigger: "blur" }],
      }
    }
  },
  created () {
    this.queryDise()
  },
  methods: {
    save () {
      return new Promise((resolve, reject) => {
        this.$refs.editor.validate().then(valid => {
          resolve(this.entity);
        }).catch(err => {
          reject(err)
        });
      })
    },
    queryDise () {
      this.diseItem = []
      if (this.entity.med_type) {
        const type = `med_type_${this.entity.med_type}`
        medApi.queryMedDictByType(type).then(res => {
          if (res && res.length) {
            this.diseItem = res.sort((a, b) => { return a.seq - b.seq })
            this.$set(this.entity, 'dise_codg', this.diseItem[0].placeDicValCode)
            this.$set(this.entity, 'dise_name', this.diseItem[0].placeDicName)
          } else {
            this.$set(this.entity, 'dise_codg', '')
            this.$set(this.entity, 'dise_name', '')
          }
        })
      }
    },
    diseChange (code) {
      const dise = this.diseItem.find(t => t.placeDicValCode === code)
      this.$set(this.entity, 'dise_name', dise?.placeDicName || '')
    }
  }
}
</script>

<style scoped>
</style>
